enum Dimension {
  WEIGHT = 'weight',
  WIDTH = 'width',
  LENGTH = 'length',
  HEIGHT = 'height',
}

export default Dimension;
